<template>
  <div class="px-4 py-3 space-y-6 max-w-6xl">
    <!-- Notifications Email / SMS / Push -->
    <div class="flex items-start justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm mt-1">Types de notifications</label>
      <div class="w-2/3 flex flex-col gap-2">
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>Email</span>
          <input type="checkbox" v-model="notifications.email" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>SMS</span>
          <input type="checkbox" v-model="notifications.sms" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>Push</span>
          <input type="checkbox" v-model="notifications.push" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
      </div>
    </div>
    <hr />

    <!-- Fréquence des notifications -->
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Fréquence des notifications</label>
      <select v-model="notificationFrequency" class="w-2/3 max-w-xs border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
        <option value="instant">Instantané</option>
        <option value="hourly">Toutes les heures</option>
        <option value="daily">Quotidien</option>
        <option value="weekly">Hebdomadaire</option>
      </select>
    </div>
    <hr />

    <!-- Paramètres d’alertes -->
    <div class="flex items-start justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm mt-1">Alertes</label>
      <div class="w-2/3 flex flex-col gap-2">
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>Rendez-vous</span>
          <input type="checkbox" v-model="alerts.appointment" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>Paiement</span>
          <input type="checkbox" v-model="alerts.payment" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
        <label
          class="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm cursor-pointer hover:bg-gray-50 transition"
        >
          <span>Activité générale</span>
          <input type="checkbox" v-model="alerts.activity" class="h-4 w-4 text-blue-500 focus:ring-2 focus:ring-blue-400 rounded" />
        </label>
      </div>
    </div>

    <!-- Bouton de sauvegarde -->
    <div class="flex justify-end pt-4">
      <button
        @click="saveNotificationSettings"
        class="bg-blue-500 text-white px-6 py-2 rounded text-sm hover:bg-blue-600 transition"
      >
        Sauvegarder
      </button>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  data() {
    return {
      notifications: {
        email: true,
        sms: false,
        push: true,
      },
      notificationFrequency: 'instant',
      alerts: {
        appointment: true,
        payment: true,
        activity: false,
      },
    };
  },
  methods: {
    async fetchNotificationSettings() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/admin/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (res.ok) {
          this.notifications = {
            email: data.notifications.email,
            sms: data.notifications.sms,
            push: data.notifications.push,
          };
          this.notificationFrequency = data.notifications.frequence || 'instant';
        }
      } catch (err) {
        console.error(err);
        toast.error("Impossible de récupérer les notifications");
      }
    },
    async saveNotificationSettings() {
      const token = localStorage.getItem("token");
      if (!token) return toast.error("Vous devez être connecté");

      try {
        const body = {
          email: this.notifications.email,
          sms: this.notifications.sms,
          push: this.notifications.push,
          frequence: this.notificationFrequency,
        };

        const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/admin/notifications", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message);

        toast.success("Paramètres de notifications sauvegardés !");
      } catch (err) {
        console.error(err);
        toast.error("Erreur lors de la sauvegarde des notifications");
      }
    },
  },
  mounted() {
    this.fetchNotificationSettings();
  },
};
</script>

<style scoped>
hr {
  border-color: #e5e7eb; /* gris clair */
}
</style>
